import React, { memo, useMemo } from 'react';
import { FaCog } from 'react-icons/fa';
import {
  FlexTableV2Dropdown,
  FlexTableV2DropdownItem,
  FlexTableV2DropdownMenu,
  FlexTableV2SettingsToggle
} from '../styles';

export const FlexTableV2SettingsDropdown = memo(
  ({
    isConfigDropdownOpen,
    toggleConfigDropdown,
    reorderingMode,
    setReorderingMode
  }) => {
    const idSufix = useMemo(() => Math.random().toString(36).substr(2, 9), []);

    return (
      <FlexTableV2Dropdown
        isOpen={isConfigDropdownOpen}
        toggle={toggleConfigDropdown}
      >
        <FlexTableV2SettingsToggle>
          <FaCog style={{ marginRight: '0' }} /> <span>Configurações</span>
        </FlexTableV2SettingsToggle>
        <FlexTableV2DropdownMenu
          container="body"
          style={{ minWidth: '350px', maxWidth: '40ch' }}
        >
          <div
            style={{
              padding: '0.5rem 1rem',
              fontWeight: 'bold',
              borderBottom: '1px solid #eee',
              marginBottom: '0.5rem'
            }}
          >
            Reordenação de Colunas
          </div>
          <FlexTableV2DropdownItem
            toggle={false}
            onClick={() => setReorderingMode('shift')}
          >
            <input
              type="radio"
              name={`reorderingMode-${idSufix}`}
              checked={reorderingMode === 'shift'}
              readOnly
              id={`flex-table-reorder-shift-${idSufix}`}
              style={{ pointerEvents: 'none', marginTop: '4px' }}
            />
            <label
              htmlFor={`flex-table-reorder-shift-${idSufix}`}
              style={{
                pointerEvents: 'none',
                margin: 0,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <span>Empurrar (Shift)</span>
              <small
                style={{
                  fontSize: '0.8em',
                  color: '#666',
                  whiteSpace: 'normal',
                  marginTop: '2px'
                }}
              >
                A coluna arrastada empurra as demais, inserindo-se na nova
                posição de forma fluida. É como funciona no Excel, por exemplo.
              </small>
            </label>
          </FlexTableV2DropdownItem>
          <FlexTableV2DropdownItem
            toggle={false}
            onClick={() => setReorderingMode('swap')}
          >
            <input
              type="radio"
              name={`reorderingMode-${idSufix}`}
              checked={reorderingMode === 'swap'}
              readOnly
              id={`flex-table-reorder-swap-${idSufix}`}
              style={{ pointerEvents: 'none', marginTop: '4px' }}
            />
            <label
              htmlFor={`flex-table-reorder-swap-${idSufix}`}
              style={{
                pointerEvents: 'none',
                margin: 0,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <span>Trocar (Swap)</span>
              <small
                style={{
                  fontSize: '0.8em',
                  color: '#666',
                  whiteSpace: 'normal',
                  marginTop: '2px'
                }}
              >
                A coluna arrastada troca diretamente de lugar com a coluna de
                destino.
              </small>
            </label>
          </FlexTableV2DropdownItem>
        </FlexTableV2DropdownMenu>
      </FlexTableV2Dropdown>
    );
  }
);
FlexTableV2SettingsDropdown.displayName = 'FlexTableV2SettingsDropdown';
